import {KeyValuePair} from './key-value-pair';
import { Host } from './host';

export class Uri {
    host: Host;
    path: string;
    queryParameters: KeyValuePair[];

    constructor() {
        this.host = new Host();
        this.queryParameters = new Array<KeyValuePair>();
    }
}





// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/uri.ts